import React from 'react';
import { object } from 'prop-types';
import classNames from 'classnames/bind';

import styles from './LinkedVehicleItem.module.scss';
import { getYearFormat, getMotorCodes } from 'utils/formatDataHelper';

const cx = classNames.bind(styles);

const LinkedVehicleItem = ({ data }) => (
  <tr className={cx('row')}>
    <td className={cx('cell')}>
      {data.vehicleDetails.manuName}
      &nbsp;
      <span className={cx('type-name')}>
        {data.vehicleDetails.modelName}
        &nbsp;
        {data.vehicleDetails.typeName}
        &nbsp;
      </span>
      <div className={cx('car-engine-codes-cell-mobile')}>
        {getMotorCodes(data.motorCodes.array)}
      </div>
    </td>

    <td className={cx('cell', 'car-engine-codes-cell')}>
      {getMotorCodes(data.motorCodes.array)}
    </td>

    <td className={cx('cell')}>
      <div className={cx('car-years')}>
        {data.vehicleDetails.yearOfConstrFrom && (
          <span className={cx('item')}>
            {getYearFormat(data.vehicleDetails.yearOfConstrFrom)}
          </span>
        )}
        <span className={cx('separator')}>&nbsp;-&nbsp;</span>
        {data.vehicleDetails.yearOfConstrTo && (
          <span className={cx('item')}>
            {getYearFormat(data.vehicleDetails.yearOfConstrTo)}
          </span>
        )}
      </div>

      <div className={cx('car-power-mobile')}>
        {data.vehicleDetails.powerKwFrom + 'kw'}
        &nbsp;&nbsp;
        {data.vehicleDetails.powerHpFrom + 'hp'}
      </div>
    </td>

    <td className={cx('cell', 'car-power-cell')}>
      {data.vehicleDetails.powerKwFrom + 'kw'}
      &nbsp;&nbsp;
      {data.vehicleDetails.powerHpFrom + 'hp'}
    </td>
  </tr>
);

LinkedVehicleItem.propTypes = {
  data: object.isRequired,
};

export default LinkedVehicleItem;



// WEBPACK FOOTER //
// ./src/pages/Product/components/LinkedArticlesTable/components/LinkedVehicleItem/LinkedVehicleItem.js